import Keycloak from "keycloak-js";

const platformRealm  = process.env.REACT_APP_KEYCLOAK_REALM  || "validaite";
const platformDomain = process.env.REACT_APP_PLATFORM_DOMAIN || ""; // e.g. "validaite.io"

/**
 * Detect tenant realm from subdomain.
 *
 * Production:  acme.validaite.io  → realm "acme"
 * Local dev:   localhost           → null  (fall through to ?realm= or localStorage)
 *
 * Reserved subdomains that belong to the platform (not tenants):
 *   www, app, platform, api, admin, keycloak
 */
function getRealmFromSubdomain() {
  if (!platformDomain) return null;
  const hostname = window.location.hostname;
  const localHosts = ["localhost", "127.0.0.1"];
  if (localHosts.some((h) => hostname === h || hostname.startsWith(h + ":"))) return null;

  if (hostname.endsWith("." + platformDomain) && hostname !== platformDomain) {
    const sub = hostname.slice(0, hostname.length - platformDomain.length - 1);
    const reserved = ["www", "app", "platform", "api", "admin", "keycloak", "dev", "qa"];
    if (sub && !reserved.includes(sub)) return sub;
  }
  return null;
}

// Realm resolution priority:
//   1. Subdomain      acme.validaite.io  → "acme"   (production)
//   2. ?realm= param  ?realm=acme        → "acme"   (shared links / local dev)
//   3. localStorage   kc_realm           → "acme"   (persisted from previous visit)
//   4. Env var / default                 → "validaite" (platform super-admin)

const subdomainRealm = getRealmFromSubdomain();
const urlParams      = new URLSearchParams(window.location.search);
const realmFromUrl   = urlParams.get("realm");
const realmFromStorage = localStorage.getItem("kc_realm");

// Password-reset / first-login tokens arrive as ?token=... — stash before any URL cleanup
// so a later ?realm= strip cannot wipe the reset link.
const tokenFromUrl = urlParams.get("token");
if (tokenFromUrl) {
  try {
    sessionStorage.setItem("pwd_reset_token", tokenFromUrl);
  } catch {
    /* ignore quota / private mode */
  }
}

export const activeRealm =
  subdomainRealm  ||
  realmFromUrl    ||
  realmFromStorage ||
  platformRealm;

export const isTenantRealm = activeRealm !== platformRealm;

// Persist so Keycloak's auth redirect doesn't lose the realm
if (subdomainRealm) {
  localStorage.setItem("kc_realm", subdomainRealm);
} else if (realmFromUrl) {
  localStorage.setItem("kc_realm", realmFromUrl);
  // Remove only ?realm= — keep other params (especially password-reset token)
  urlParams.delete("realm");
  const remaining = urlParams.toString();
  const cleanUrl =
    window.location.pathname +
    (remaining ? `?${remaining}` : "") +
    window.location.hash;
  window.history.replaceState({}, "", cleanUrl);
}

const keycloak = new Keycloak({
  url:      process.env.REACT_APP_KEYCLOAK_URL || "http://localhost:8081",
  realm:    activeRealm,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "validaite-frontend",
});

export default keycloak;
